export default __webpack_public_path__ + "static/home-compute2-image-964dc2a60303f4ca80d28dfb1ff897f8.png";